import { LogEntry } from '../types';

type Listener = (logs: LogEntry[]) => void;

class Logger {
  private logs: LogEntry[] = [];
  private listeners: Set<Listener> = new Set();

  public log(level: 'info' | 'success' | 'warn' | 'error', message: string) {
    const timestamp = new Date().toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
    const entry: LogEntry = { timestamp, level, message };
    this.logs.unshift(entry);
    if (this.logs.length > 300) {
      this.logs.pop();
    }
    this.notify();
  }

  public info(message: string) {
    this.log('info', message);
  }

  public success(message: string) {
    this.log('success', message);
  }

  public warn(message: string) {
    this.log('warn', message);
  }

  public error(message: string) {
    this.log('error', message);
  }

  public getLogs(): LogEntry[] {
    return [...this.logs];
  }

  public clear() {
    this.logs = [];
    this.notify();
  }

  public subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    listener([...this.logs]);
    return () => this.listeners.delete(listener);
  }

  private notify() {
    for (const listener of this.listeners) {
      listener([...this.logs]);
    }
  }
}

export const appLogger = new Logger();
